import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThunder: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="thunder,zap, flash"><path d="M19.5 9.75H13.0357L14.0714 2.75L4.5 14.25H10.9643L9.92857 21.25L19.5 9.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconThunder;
